import React from "react";
import { useMoralis } from "react-moralis";
import SignedOut from "../components/SignedOut";
import { Col } from "antd";
import Main from "./Main";
import { useEffect } from "react";
const APIKEY = process.env.REACT_APP_MAGIC_APIKEY;

const Login = () => {
  const { Moralis, isWeb3Enabled, isAuthenticated, isWeb3EnableLoading, user } =
    useMoralis();

  useEffect(() => {
    if (isAuthenticated && !isWeb3Enabled && !isWeb3EnableLoading) {
      async function init() {
        const customNodeOptions = {
          rpcUrl:
            "https://rpc-mumbai.maticvigil.com/v1/0fcf175a341230e99aa167effa08019b483e2627", // Polygon RPC URL
          chainId: 80001, // Polygon chain id
        };

        //Magic Authentication
        let options = {
          provider: "magicLink",
          email: user.get("email"),
          apiKey: APIKEY, // Enter API key from Magic Dashboard https://dashboard.magic.link/
          network: customNodeOptions,
        };
        Moralis.enableWeb3(options);
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }
      init();
    }
  }, [isAuthenticated, isWeb3Enabled, isWeb3EnableLoading]);

  return (
    <Col align="center" className="login-container">
      {isAuthenticated ? <Main /> : <SignedOut />}
    </Col>
  );
}

export default Login;
